/* import __COLOCATED_TEMPLATE__ from './learn-button.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { openTutorial } from 'embercom/helpers/open-tutorial';

export default class LearnButtonComponent extends Component {
  @service declare appService: AppService;
  @service declare intl: IntlService;
  @service declare modalService: any;
  get learnArticles() {
    if (this.appService.app.isStandaloneApp) {
      return [
        {
          items: [
            {
              text: this.intl.t('ai-agent.guidance.how-to-use-article'),
              icon: 'article',
              onSelectItem: () => {
                window.Intercom('showArticle', 10644329);
              },
            },
            {
              text: this.intl.t('ai-agent.guidance.best-practices-article'),
              icon: 'article',
              onSelectItem: () => {
                window.Intercom('showArticle', 10644781);
              },
            },
          ],
        },
      ];
    }
    let articles = [
      {
        items: [
          {
            text: this.intl.t('ai-agent.guidance.how-to-use-article'),
            icon: 'article',
            onSelectItem: () => {
              window.Intercom('showArticle', 10210126);
            },
          },
          {
            text: this.intl.t('ai-agent.guidance.best-practices-article'),
            icon: 'article',
            onSelectItem: () => {
              window.Intercom('showArticle', 10560969);
            },
          },
          {
            text: this.intl.t('ai-agent.guidance.fin-tone-and-identity-article'),
            icon: 'article',
            onSelectItem: () => {
              window.Intercom('showArticle', 9794969);
            },
          },
        ],
      },
    ];
    articles[0].items.push({
      text: this.intl.t('ai-agent.guidance.banner.tutorial-button'),
      icon: 'education',
      onSelectItem: () => {
        openTutorial('4', 'guidance', 'learn_dropdown', this.modalService);
      },
    });
    return articles;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Guidance::LearnButton': typeof LearnButtonComponent;
    'ai-agent/guidance/learn-button': typeof LearnButtonComponent;
  }
}
